/**
 * `PhoneAntd` is a React functional component that wraps an Ant Design `Input` component.
 * It uses `forwardRef` to pass a ref to the input element, allowing parent components to
 * directly interact with the input's DOM node.
 *
 * @param {object} props - The properties passed to the `Input` component.
 * @param {React.Ref} ref - The ref forwarded to the input element.
 *
 * @returns {JSX.Element} A rendered Ant Design `Input` component with forwarded ref.
 */
import "react-phone-number-input/style.css";

import { Input } from "antd";
import { forwardRef, useImperativeHandle, useRef } from "react";

export const PhoneAntd = forwardRef((props, ref) => {
  const inputRef = useRef(null);

  useImperativeHandle(ref, () => {
    return inputRef.current.input;
  }, []);
  return <Input {...props} ref={inputRef} />;
});
PhoneAntd.displayName = "PhoneAntd";
